import {
  NOTIFICATION_GET_LIST,
  NOTIFICATION_SET_READ,
  NOTIFICATION_REQUEST,
  NOTIFICATION_SUCCESS,
  NOTIFICATION_ERROR
} from "@/store/types"

import axios from "@/store/axios"

const state = {
  notifications: null,
  page: 1,
  totalCount: 0,
  search: "",
  isLoading: false,
  error: null
}

const getters = {
  getNotifications: (state) => state.notifications,
  getNotificationUnreadCount: (state) =>
    state.notifications && state.notifications.filter((n) => n.unread)
      ? state.notifications.filter((n) => n.unread).length
      : 0,
  getNotificationCurrentPage: (state) => state.page,
  getNotificationTotalCount: (state) => state.totalCount,
  isNotificationLoading: (state) => state.isLoading,
  getNotificationError: (state) => state.error
}

const actions = {
  [NOTIFICATION_GET_LIST]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(NOTIFICATION_REQUEST)

      axios
        .get("/api/v3/notifications/")
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(NOTIFICATION_SUCCESS, { notifications: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(NOTIFICATION_ERROR, err)
          reject(err)
        })
    })
  },
  [NOTIFICATION_SET_READ]: ({ commit }, { id }) => {
    return new Promise((resolve, reject) => {
      commit(NOTIFICATION_REQUEST)

      axios
        .patch(`/api/v3/notifications/${id}/`, { unread: false })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(NOTIFICATION_SUCCESS, { notification: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(NOTIFICATION_ERROR, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [NOTIFICATION_REQUEST]: (state) => {
    state.isLoading = true
  },
  [NOTIFICATION_SUCCESS]: (state, { notifications, notification }) => {
    state.isLoading = false

    if (notifications) {
      state.notifications = notifications.results
      state.page = notifications.page
      state.totalCount = notifications.count
    }

    if (notification) {
      state.notifications = [
        notification,
        ...state.notifications.filter((n) => n.id !== notification.id)
      ]
    }
  },
  [NOTIFICATION_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
